import { Component, Inject } from '@angular/core';
import { OPERATION_OVERLAY_LARGE_CONTENT_DATA } from '@fi-app/utilities/operation-overlay-large/operation-overlay-large-dialog/operation-overlay-large-dialog.component';

@Component({
    selector: 'fi-document-view-dialog',
    templateUrl: './document-view-dialog.component.html',
    standalone: false,
})
export class FiDocumentViewDialogComponent {
    constructor(@Inject(OPERATION_OVERLAY_LARGE_CONTENT_DATA) public data) {}
}
